import styled, { css } from 'styled-components';
import { StyledReceiptSpinner } from '../components/ReceiptSpinner/styles/receipt-spinner.styled';
export const receiptStyles = ({ $isLoading }) => css `
	position: relative;

	${$isLoading &&
    css `
		position: relative;
		user-select: none;
		pointer-events: none;

		& > *:not(${StyledReceiptSpinner}) {
			transition: opacity 0.2s;
			opacity: 0.2;
		}
	`}
`;
export const StyledReceipt = styled.div `
	${receiptStyles}
`;
